import React from 'react'
import { Button } from '@missionlabs/smartagent-app-components';

import MuteCh1Off from './MuteCh1Off.svg';
import MuteCh2Off from './MuteCh2Off.svg';
import MuteCh1On from './MuteCh1On.svg';
import MuteCh2On from './MuteCh2On.svg';
import { IWaveformChannel } from './AudioPlayer';
import { Waveform } from './Waveform';

interface Props {
    channel?: IWaveformChannel;
    currentTimePercentage: number;
    id: number;
    muted: boolean;
    width: number;
    onSeek(e: React.MouseEvent<HTMLDivElement>, seek: boolean): void;
    muteChannel(ch: number): void;
}

export const Track: React.FC<Props> = ({ channel, currentTimePercentage, id, muted, onSeek, width, ...actions }) => {
    const getMutedIcon = () => {
        return muted ? MuteCh1On : MuteCh1Off;
    }

    const getAltString = () => {
        if (id === 1) return muted ? "Unmute agent" : "Mute agent";

        return muted ? "Unmute customer" : "Mute customer"
    }

    return (
        <div className={`track track-${id}`}>
            <Button onClick={() => actions.muteChannel(id)} className="mute" title={getAltString()}>
                <img src={getMutedIcon()} alt={getAltString()} title={getAltString()} />
            </Button>

            <Waveform
                id={id}
                width={width}
                channel={channel}
                currentTimePercentage={currentTimePercentage}
                onSeek={onSeek}
            />
        </div>
    )
}